<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    :width="width"
    top="0"
    custom-class="crm-form-dialog crm-form-dialog--wide"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    destroy-on-close
    @closed="$emit('closed')"
  >
    <div class="crm-form-dialog__body">
      <slot />
    </div>
    <div v-if="$slots.footer" slot="footer" class="dialog-footer">
      <slot name="footer" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RecordFormDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    /** Wide modal; cap width for readability on large monitors */
    width: { type: String, default: 'min(1280px, 96vw)' }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    }
  }
}
</script>
